// =====================================================================
// Validadores e máscaras do portal (CPF, email, telefone, data).
// Portados do UEN. Funções retornam { valid, error? } quando validam,
// e as máscaras formatam string pra exibição.
// =====================================================================

// ---- CPF ----
export function onlyDigits(v) {
    return String(v || '').replace(/\D/g, '');
}

export function formatCPF(v) {
    const d = onlyDigits(v).slice(0, 11);
    return d
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
}

export function validateCPF(input) {
    const cpf = onlyDigits(input);
    if (cpf.length !== 11) return { valid: false, error: 'CPF deve ter 11 dígitos.' };
    if (/^(\d)\1{10}$/.test(cpf)) return { valid: false, error: 'CPF inválido.' };

    const calcDigito = (base, pesoInicial) => {
        let soma = 0;
        for (let i = 0; i < base.length; i++) soma += Number(base[i]) * (pesoInicial - i);
        const resto = (soma * 10) % 11;
        return resto === 10 ? 0 : resto;
    };
    const d1 = calcDigito(cpf.slice(0, 9), 10);
    const d2 = calcDigito(cpf.slice(0, 10), 11);
    if (d1 !== Number(cpf[9]) || d2 !== Number(cpf[10])) {
        return { valid: false, error: 'CPF inválido.' };
    }
    return { valid: true };
}

// ---- Email ----
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateEmail(input) {
    const email = String(input || '').trim();
    if (!email) return { valid: false, error: 'Informe o email.' };
    if (email.length > 254) return { valid: false, error: 'Email muito longo.' };
    if (!EMAIL_RE.test(email)) return { valid: false, error: 'Email inválido.' };
    return { valid: true };
}

// Provedores aceitos no CADASTRO (evita typo/descartáveis no e-mail novo).
const PROVEDORES_PERMITIDOS = [
    'gmail.com', 'icloud.com', 'hotmail.com', 'hotmail.com.br',
    'outlook.com', 'outlook.com.br', 'live.com', 'live.com.br', 'bol.com.br',
    'yahoo.com', 'yahoo.com.br',
];

export function validateEmailCadastro(input) {
    const base = validateEmail(input);
    if (!base.valid) return base;
    const dominio = String(input).trim().toLowerCase().split('@')[1];
    if (!PROVEDORES_PERMITIDOS.includes(dominio)) {
        return { valid: false, error: 'Use um provedor comum (Gmail, Outlook, iCloud…).' };
    }
    return { valid: true };
}

// ---- Telefone ----
export function formatPhone(v) {
    const d = onlyDigits(v).slice(0, 11);
    if (d.length <= 10) {
        return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
    }
    return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
}

export function validatePhone(input) {
    const d = onlyDigits(input);
    if (d.length === 11 && d[2] === '9') return { valid: true };
    if (d.length === 10) return { valid: true };
    return { valid: false, error: 'Telefone inválido (DDD + número).' };
}

// ---- Data de nascimento (YYYY-MM-DD do input date) ----
export function validateDateOfBirth(input) {
    if (!input) return { valid: false, error: 'Informe a data de nascimento.' };
    const partes = String(input).split('-');
    if (partes.length !== 3) return { valid: false, error: 'Data inválida.' };
    const [ano, mes, dia] = partes.map(Number);
    const data = new Date(ano, mes - 1, dia);
    if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) {
        return { valid: false, error: 'Data inválida.' };
    }
    const hoje = new Date();
    if (data > hoje) return { valid: false, error: 'Data não pode ser no futuro.' };
    let idade = hoje.getFullYear() - ano;
    const passouAniversario =
        hoje.getMonth() > mes - 1 || (hoje.getMonth() === mes - 1 && hoje.getDate() >= dia);
    if (!passouAniversario) idade -= 1;
    if (idade < 5 || idade > 100) return { valid: false, error: 'Idade fora do intervalo aceito.' };
    return { valid: true };
}

// ---- Datas (exibição) ----
export function formatDateBR(dateString) {
    if (!dateString) return '';
    const iso = String(dateString).slice(0, 10);
    const [ano, mes, dia] = iso.split('-');
    if (!ano || !mes || !dia) return '';
    return `${dia}/${mes}/${ano}`;
}
